import L from 'leaflet';
import markerIconGreen from '../img/poi-green.svg'
import markerIconYellow from '../img/poi-yellow.svg'
import markerIconOrange from '../img/poi-orange.svg'
import markerIconRed from '../img/poi-red.svg'
import markerIconDarkRed from '../img/poi-darkred.svg'
import markerIconGrey from '../img/poi-grey.svg'

import markerHtGreen from '../img/poi-green-active.svg'
import markerHtYellow from '../img/poi-yellow-active.svg'
import markerHtOrange from '../img/poi-orange-active.svg'
import markerHtRed from '../img/poi-red-active.svg'
import markerHtDarkRed from '../img/poi-darkred-active.svg'
import markerHtGrey from '../img/poi-grey-active.svg'

import markerShadow from '../img/marker-shadow.png'

export const greenIcon  = L.icon({
    iconUrl: markerIconGreen,
    shadowUrl: markerShadow,

    iconSize: [25, 41],
    shadowSize: [41, 41],
    iconAnchor: [13, 41],
    shadowAnchor: [13, 41],
    popupAnchor: [0, -40],
});

export const yellowIcon  = L.icon({
    iconUrl: markerIconYellow,
    shadowUrl: markerShadow,

    iconSize: [25, 41],
    shadowSize: [41, 41],
    iconAnchor: [13, 41],
    shadowAnchor: [13, 41],
    popupAnchor: [0, -40],
});

export const orangeIcon  = L.icon({
    iconUrl: markerIconOrange,
    shadowUrl: markerShadow,

    iconSize: [25, 41],
    shadowSize: [41, 41],
    iconAnchor: [13, 41],
    shadowAnchor: [13, 41],
    popupAnchor: [0, -40],
});

export const redIcon  = L.icon({
    iconUrl: markerIconRed,
    shadowUrl: markerShadow,

    iconSize: [25, 41],
    shadowSize: [41, 41],
    iconAnchor: [13, 41],
    shadowAnchor: [13, 41],
    popupAnchor: [0, -40],
});

export const darkredIcon  = L.icon({
    iconUrl: markerIconDarkRed,
    shadowUrl: markerShadow,

    iconSize: [25, 41],
    shadowSize: [41, 41],
    iconAnchor: [13, 41],
    shadowAnchor: [13, 41],
    popupAnchor: [0, -40],
});

export const greyIcon  = L.icon({
    iconUrl: markerIconGrey,
    shadowUrl: markerShadow,

    iconSize: [25, 41],
    shadowSize: [41, 41],
    iconAnchor: [13, 41],
    shadowAnchor: [13, 41],
    popupAnchor: [0, -40],
});

export const activeGreenIcon = L.icon({
    iconUrl: markerHtGreen,
    shadowUrl: markerShadow,

    iconSize: [35, 41],
    shadowSize: [41, 41],
    iconAnchor: [13, 41],
    shadowAnchor: [13, 41],
    popupAnchor: [0, -40],
});

export const activeYellowIcon = L.icon({
    iconUrl: markerHtYellow,
    shadowUrl: markerShadow,

    iconSize: [35, 41],
    shadowSize: [41, 41],
    iconAnchor: [13, 41],
    shadowAnchor: [13, 41],
    popupAnchor: [0, -40],
});

export const activeOrangeIcon = L.icon({
    iconUrl: markerHtOrange,
    shadowUrl: markerShadow,

    iconSize: [35, 41],
    shadowSize: [41, 41],
    iconAnchor: [13, 41],
    shadowAnchor: [13, 41],
    popupAnchor: [0, -40],
});

export const activeRedIcon = L.icon({
    iconUrl: markerHtRed,
    shadowUrl: markerShadow,

    iconSize: [35, 41],
    shadowSize: [41, 41],
    iconAnchor: [13, 41],
    shadowAnchor: [13, 41],
    popupAnchor: [0, -40],
});

export const activeDarkRedIcon = L.icon({
    iconUrl: markerHtDarkRed,
    shadowUrl: markerShadow,

    iconSize: [35, 41],
    shadowSize: [41, 41],
    iconAnchor: [13, 41],
    shadowAnchor: [13, 41],
    popupAnchor: [0, -40],
});

export const activeGreyIcon = L.icon({
    iconUrl: markerHtGrey,
    shadowUrl: markerShadow,

    iconSize: [35, 41],
    shadowSize: [41, 41],
    iconAnchor: [13, 41],
    shadowAnchor: [13, 41],
    popupAnchor: [0, -40],
});
